import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Route, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { SeedsService } from 'src/app/services/seeds.service';

@Component({
  selector: 'app-ruteros',
  templateUrl: './ruteros.component.html',
  styleUrls: ['./ruteros.component.scss'],
})
export class RuterosComponent implements OnInit {

  public foto
  public nombre
  public correo: any;
  public municipio: any;
  public ciudad: any;
  public puntosSemilla: number=0;
  public ruterosSemilla: any;
  public authen
  role: any;
  proveedor: any;
  constructor(
    private auth:AuthService, 
    private authing:AngularFireAuth,
    private seeds:SeedsService,
    private route:Router,
    private router:NavController) { 
      
    this.authing.auth.onAuthStateChanged(f=>{
        this.authen=f.uid
    })
    this.sessionData()  
  }

  ngOnInit() {
  

  }

  gotoSeeds(){
     this.route.navigate(['/seeds'])
  }
  gotoRouters(){
    this.router.navigateForward('/recaudos')

  }
  async sessionData(){
    this.authing.auth.onAuthStateChanged(k=>{
       this.auth.datosPefilSesion(k.uid).subscribe(o=>{
           this.foto=o.data()['foto']
           this.nombre=o.data()['nombre']
           this.correo=o.data()['email']
           this.ciudad=o.data()['ciudad']
           this.role=o.data()['role']
           this.municipio=o.data()['municipio']
           if(this.role=='4'){
             this.proveedor=o.data()['proveedor']
             this.traerPuntosSemillaCreados()

           }
       })
  
    })
   }
   traerPuntosSemillaCreados(){
    this.seeds.devolverPuntosSemillaProveedores(this.proveedor).subscribe(j=>{
        this.puntosSemilla=j.docs.length
    })
  }


}
